import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import { Actions } from "@/store/enums/StoreEnums";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/prismjs";
import "bootstrap";

import { msalPlugin } from "@/plugins/msalPlugin";
import {
  msalInstance,
  loginRequest,
  silentTokenRequest,
  msalInstanceReset,
  resetPasswordRequest,
} from "./authConfig";
import {
  AuthenticationResult,
  EventType,
  EventMessage,
  AuthError,
} from "@azure/msal-browser";
import { CustomNavigationClient } from "@/router/NavigationClient";
import LoaderVue from "@/components/utility/LoaderInsidePage.vue";
import LoadingVue from "vue3-loading-overlay";
import "vue3-loading-overlay/dist/vue3-loading-overlay.css";

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

const loadOptions = async () => {
  store
    .dispatch(`OptionsModule/${Actions.FETCH_OPTIONS_VALUES}`)
    .catch((error) => {
      console.error("Errore nel caricamento delle opzioni globali:", error);
    });
};

const navigationClient = new CustomNavigationClient(router);
msalInstance.setNavigationClient(navigationClient);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();

const logout = () => {
  localStorage.clear();
  msalInstance.logoutRedirect();
};

if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);

  msalInstance.acquireTokenSilent(silentTokenRequest).then((userInfo) => {
    localStorage.setItem("tokenAdb2c", userInfo.idToken);
    loadOptions();
  });
}

msalInstance.addEventCallback(async (event: EventMessage) => {
  if (
    event.eventType === EventType.ACQUIRE_TOKEN_NETWORK_START &&
    accounts[0] &&
    accounts[0].idTokenClaims &&
    typeof accounts[0]?.idTokenClaims?.exp === "number" &&
    Date.now() > accounts[0]?.idTokenClaims?.exp * 1000 // ✅ Usa Date.now() dinamicamente
  ) {
    // logout();
    await msalInstance.acquireTokenSilent(loginRequest).then((userInfo) => {
      localStorage.setItem("tokenAdb2c", userInfo.idToken);
      store.commit("setToken", userInfo.idToken);
      store.commit("setUser", msalInstance.getActiveAccount());
    });
  }

  if (event.eventType === EventType.LOGIN_FAILURE) {
    const error = event.error;
    if (
      error instanceof AuthError &&
      error.errorMessage?.includes("AADB2C90118")
    ) {
      msalInstanceReset.loginRedirect(resetPasswordRequest);
    } else logout();
  }
  if (
    event.eventType === EventType.ACQUIRE_TOKEN_FAILURE ||
    event.eventType === EventType.SSO_SILENT_FAILURE
  ) {
    logout();
  }

  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
    await msalInstance
      .acquireTokenSilent(loginRequest)
      .then(async (userInfo: AuthenticationResult) => {
        localStorage.setItem("tokenAdb2c", userInfo.idToken);
        // loadOptions();
      });
  }
});

const app = createApp(App);

app.use(store);
app.use(router);
app.use(msalPlugin, msalInstance);

ApiService.init(app);
initInlineSvg(app);
initVeeValidate();
app.use(ElementPlus, { size: "small", zIndex: 3000 });
app.component("LoadingVue", LoadingVue).component("LoaderVue", LoaderVue);

// Carica le opzioni globali all'avvio dell'app

// store
//   .dispatch(`OptionsModule/${Actions.FETCH_OPTIONS_VALUES}`)
//   .catch((error) => {
//     console.error("Errore nel caricamento delle opzioni globali:", error);
//   });

app.mount("#app");
console.log(window);

if ("hid" in navigator) {
  // The WebHID API is supported.
  console.log("The WebHID API is supported");
}
if ("NDEFReader" in window) {
  /* Scan and write NDEF Tags */ console.log("NDEFReader");
}
